import axios from 'axios';

import { refreshTokens } from '@services/auth.service';
import { getItem } from '@services/local-storage.service';

function registerAxiosInterceptor(errorCallback) {
  let isRefreshing = false;
  let refreshSubscribers = [];

  function executeSubscribers(error) {
    refreshSubscribers.forEach((promise) => {
      if (error) {
        promise.reject(error);
      } else {
        promise.resolve();
      }
    });

    refreshSubscribers = [];
  }

  // **Attach access token to every request**
  axios.interceptors.request.use(
    (config) => {
      const accessToken = getItem('accessToken');
      if (accessToken && config.url.includes(import.meta.env.VITE_API_URL)) {
        // eslint-disable-next-line no-param-reassign
        config.headers.Authorization = `Bearer ${accessToken}`;
      }
      return config;
    },
    error => Promise.reject(error),
  );

  axios.interceptors.response.use(
    // success response => just return response
    response => response,
    // error occured => check if it's an authentication error
    (error) => {
      const { config, response } = error;

      const originalRequest = config;

      if (response.status !== 401) {
        return Promise.reject(error);
      }

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          refreshSubscribers.push({ resolve, reject })
        }).then(() => axios(originalRequest))
          .catch(err => Promise.reject(err));
      }

      isRefreshing = true;
      return new Promise((resolve, reject) => {
        refreshTokens()
          .then(() => {
            executeSubscribers();
            resolve(axios(originalRequest));
          })
          .catch((err) => {
            executeSubscribers(err);
            reject(err);
            errorCallback();
          })
          .finally(() => {
            isRefreshing = false;
          });
      });
    },
  );
}

export {
  registerAxiosInterceptor,
};